import { makeStyles } from 'tss-react/mui';

export default makeStyles<{ variant: 'warning' | 'danger' }>({ name: 'LicenseIssue' })((_theme, props) => ({
    root: {
        display: 'flex',
        padding: 8,
        flexDirection: 'column',
        borderRadius: 8,
        gap: 12,
        background: props.variant === 'warning' ? '#FCF2DE' : props.variant === 'danger' ? '#FFEBED' : undefined
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 4
    },
    title: {
        color: props.variant === 'warning' ? '#232323' : props.variant === 'danger' ? '#FF5342' : undefined,
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.26px'
    },
    description: {
        color: '#232323',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
        letterSpacing: '-0.24px',
        opacity: 0.8
    },
    action: {
        padding: '8px 16px',
        borderRadius: 8,
        background: '#232323 !important',
        color: '#FFFFFF',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        boxSizing: 'border-box'
    }
}));
